/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsConstantContactFormViewProps } from './hosports-constant-contact-form';

export default (props: IHosportsConstantContactFormViewProps) => {
    return (
        <div>{'todo'}</div>
    );
};
